import { useRef } from "react";
import { useDispatch } from "react-redux";

import { inputControls } from "redux/actions";

export const useControlsCore = () => {
  const dispatch = useDispatch();

  const animationFrameId = useRef<number>();
  const lastDispatchTime = useRef<number>(0);
  const currentDirection = useRef<string>("");

  const updateControls = (time: number) => {
    const deltaTime = time - lastDispatchTime.current;

    dispatch(
      inputControls({
        command: currentDirection.current,
        isInputEnd: false,
        delta: deltaTime / 1000, // in seconds
      })
    );
    lastDispatchTime.current = time;

    animationFrameId.current = requestAnimationFrame((time) => {
      updateControls(time);
    });
  };

  const onInputStart = (command: string) => {
    currentDirection.current = command;

    if (!animationFrameId.current) {
      lastDispatchTime.current = performance.now();
      animationFrameId.current = requestAnimationFrame((time) => {
        updateControls(time);
      });
    }
  };
  const onInputEnd = (command: string) => {
    // Send the input end immediately
    dispatch(
      inputControls({
        command,
        isInputEnd: true,
        delta: 0,
      })
    );

    if (animationFrameId.current) {
      cancelAnimationFrame(animationFrameId.current);
      animationFrameId.current = undefined;
    }
  };

  return {
    onInputStart,
    onInputEnd,
  };
};
